import { Store } from './rootReducer';

//Types
export enum CandidateFeedbackDashboardAction {
  'SET_CANDIDATE_FEEDBACK_DASHBOARD' = 'SET_CANDIDATE_FEEDBACK_DASHBOARD',
}

export interface CandidateFeedbackDashboard {
  candFBDashShowing: boolean;
}

const initialState: CandidateFeedbackDashboard = {
  candFBDashShowing: false,
};

// Actions
export type Action =
  | {
      type: CandidateFeedbackDashboardAction.SET_CANDIDATE_FEEDBACK_DASHBOARD;
      payload: boolean;
    };

// Reducer
export default function DashboardInfoReducer(
  state = initialState,
  action: Action
): CandidateFeedbackDashboard {
  if (action.type === CandidateFeedbackDashboardAction.SET_CANDIDATE_FEEDBACK_DASHBOARD) {
    return { 
      ...state, 
      candFBDashShowing: true 
    };
  }
  return state;
}

// Action creators
export const setCandFBDashReportShowing = (payload: CandidateFeedbackDashboard) => ({
  type: CandidateFeedbackDashboardAction.SET_CANDIDATE_FEEDBACK_DASHBOARD,
  payload,
});

// Selectors
export const selectCandFBDashReportShowing = (app: Store) => app.candidateDashboardFeedback.candFBDashShowing;
